export class Constants {

    public static SupportEmail:string = "mailto:membersupport-apis@vizientinc.com";
  }